/**
 * ANJA custom analytics events, published to Shopify Customer Events (Shopify.analytics.publish).
 * Standard events (page_viewed, product_viewed, product_added_to_cart, checkout_*) are already sent by
 * Shopify to the Google & YouTube and Facebook & Instagram channels. A custom pixel can subscribe to
 * these extra events and forward them to GA4 / Meta (see SETUP-AND-INTEGRATIONS.md).
 *
 * Events: anja_whatsapp_click, anja_call_click, anja_contact_open, anja_size_guide_open,
 * anja_age_finder_submit, anja_wishlist_toggle, anja_kit_add, anja_look_add, anja_landing_cta,
 * anja_campaign_cta, anja_quick_link, anja_pair_added (from the cart drawer script).
 */
const publish = (name, data = {}) => {
  try {
    window.Shopify?.analytics?.publish?.(name, { page: location.pathname, ...data });
  } catch {
    /* analytics must never break the page */
  }
};

if (!window.__anjaAnalytics) {
  window.__anjaAnalytics = true;

  document.addEventListener(
    'click',
    (event) => {
      const t = /** @type {HTMLElement} */ (event.target);
      const a = t.closest?.('a, button');
      if (!a) return;
      const href = a.getAttribute('href') || '';
      const text = (a.textContent || '').trim().slice(0, 60);

      if (/wa\.me|whatsapp\.com/.test(href)) publish('anja_whatsapp_click', { label: text, from: a.closest('[class*="anja-"]')?.className.split(' ')[0] || '' });
      else if (href.startsWith('tel:')) publish('anja_call_click', { label: text });
      if (a.closest('[data-anja-contact-open]')) publish('anja_contact_open', {});
      if (a.closest('.anja-size-guide__open, [data-anja-open-size-guide]')) publish('anja_size_guide_open', { product: document.querySelector('h1')?.textContent?.trim() || '' });
      if (a.closest('[data-anja-wish]')) publish('anja_wishlist_toggle', { handle: /** @type {HTMLElement} */ (a.closest('[data-anja-wish]')).dataset.anjaWish || '' });
      if (a.closest('.anja-bundle [data-anja-add]')) publish('anja_kit_add', { product: document.querySelector('h1')?.textContent?.trim() || '' });
      else if (a.closest('anja-look [data-anja-add]')) publish('anja_look_add', {});
      if (a.closest('.anja-lp-hero__ctas, .anja-lp-more')) publish('anja_landing_cta', { label: text });
      if (a.closest('.anja-campaign__ctas, .anja-cbar')) publish('anja_campaign_cta', { label: text });
      if (a.closest('.anja-lp-chips')) publish('anja_quick_link', { label: text });
    },
    { capture: true }
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = /** @type {HTMLElement} */ (event.target);
      if (form.closest?.('anja-age-finder')) {
        const data = new FormData(/** @type {HTMLFormElement} */ (form));
        publish('anja_age_finder_submit', { age: data.get('anja_age'), sport: data.get('anja_sport') || '' });
      }
    },
    { capture: true }
  );
}
